<seds-loaders-core [mode]="mode" [current]="current" [total]="total" [type]="type" [percentage]="percentage">
</seds-loaders-core>
